import { createSlice } from "@reduxjs/toolkit";
import { api } from "service/api";
import { workAreasApi } from "service/apiVariables";
import { Toast } from "service/toast";
import { setLoader } from "./loader";
import { addQuery } from "helpers/utis";

export const workAreaSlice = createSlice({
  name: "workArea",
  initialState: {
    workAreas: null,
    isLoading: false,
    workAreaData: {},
    activeWorkArea: null,
    inactiveWorkArea: null,
  },
  reducers: {
    saveWorkAreasList: (state, action) => {
      state.workAreas = action.payload || [];
      state.isLoading = false;
    },

    saveWorkAreaData: (state, action) => {
      state.workAreaData = action.payload || null;
      state.isLoading = false;
    },

    setSelectedActiveWorkArea: (state, action) => {
      state.activeWorkArea = action.payload;
    },

    setSelectedInactiveWorkArea: (state, action) => {
      state.inactiveWorkArea = action.payload;
    },
  },
});

// same list api, just send type: active / inactive
export const getWorkAreaListAct = (query) => (dispatch) => {
  workAreasApi.getWorkAreasListApi.addQuery = query;

  addQuery(query || {}, workAreasApi.getWorkAreasListApi);
  dispatch(setLoader(true));

  return new Promise((resolve, reject) => {
    api({ ...workAreasApi.getWorkAreasListApi })
      .then(({ data }) => {
        dispatch(saveWorkAreasList(data));
        dispatch(setLoader(false));
        resolve(data);
      })
      .catch((err) => {
        if (err?.status === 400) {
          dispatch(saveWorkAreasList(err?.data));
          dispatch(setLoader(false));
          resolve(err?.data);
        } else {
          dispatch(setLoader(false));
          reject(Toast({ type: "error", message: err?.message }));
        }
      });
  });
};

export const getWorkAreaByIdAct = (id) => (dispatch) => {
  dispatch(setLoader(true));

  const baseConfig = workAreasApi.getWorkAreasByIdApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        dispatch(saveWorkAreaData(data?.data));
        dispatch(setLoader(false));
        resolve(data?.data);
      })
      .catch(({ message }) => {
        dispatch(setLoader(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

// add work area
export const createWorkAreaAct = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...workAreasApi.createWorkAreasApi, body })
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Work Area added successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// update work area
export const updateWorkAreaAct = (id, body) => () => {
  const baseConfig = workAreasApi.updateWorkAreasApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
    body,
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Work Area updated successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// active -> inactive OR delete based on backend behavior
export const deleteWorkAreaAct = (id) => () => {
  const baseConfig = workAreasApi.deleteWorkAreasApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Work Area deleted successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// inactive -> active
export const activateWorkAreaAct = (id, status) => () => {
  const baseConfig = workAreasApi.changeWorkAreaStatusApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id, status),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message:
            data?.message ||
            `Work Area ${status === "active" ? "activated" : "inactivated"} successfully`,
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const {
  saveWorkAreasList,
  saveWorkAreaData,
  setSelectedActiveWorkArea,
  setSelectedInactiveWorkArea,
} = workAreaSlice.actions;

export default workAreaSlice.reducer;
